import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavLink as Link} from 'react-router-dom';
import {Menu, Button} from 'antd';
import {LOGOUT_REQUEST, onHandleLogoutRequest} from '../../../modules/auth/redux';

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

class RightMenu extends Component {
  render() {
    const {logout, isMobile} = this.props;
    return (
      <Menu mode="horizontal" >
        <Menu.Item key={`home${isMobile ? '-m' : ''}`} style={{paddingTop: 10}}>
          <Button type='link' to="/creative/home">Home</Button>
        </Menu.Item>
        <Menu.Item key={`network${isMobile ? '-m' : ''}`} style={{paddingTop: 10}}>
          <Button type='link' to="/network">Network</Button>
        </Menu.Item>
        <Menu.Item key={`jobs${isMobile ? '-m' : ''}`} style={{paddingTop: 10}}>
          <Button type='link' to="/jobs">Jobs</Button>
        </Menu.Item>
        <Menu.Item key={`messaging${isMobile ? '-m' : ''}`} style={{paddingTop: 10}}>
          <Button type='link' to="/messaging">Messaging</Button>
        </Menu.Item>
        <Menu.Item key={`notifications${isMobile ? '-m' : ''}`} style={{paddingTop: 10}}>
          <Button type='link' to="/notifications">Notifications</Button>
        </Menu.Item>
        <Menu.Item key={`logout${isMobile ? '-m' : ''}`} style={{paddingTop: 10}}>
          <Button type="link" onClick={logout}>Logout</Button>
        </Menu.Item>
      </Menu>
    );
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    logout: () => {dispatch({type: LOGOUT_REQUEST})}
  };
};

export default connect(null, mapDispatchToProps)(RightMenu);
